module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-nissan.6c46f063.png";